import DeclinedEngagements from '@dashboardWirelineRetentionDepartment/DeclinedEngagements/DeclinedEngagements';

export default DeclinedEngagements;
